import { render, staticRenderFns } from "./BootsaleForm.vue?vue&type=template&id=8f2e423e&"
import script from "./BootsaleForm.vue?vue&type=script&lang=js&"
export * from "./BootsaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports